module.exports = __webpack_public_path__ + "img/logo.af889880.png";